<template>
  <div>
    <v-card
      class="card-curvey d-flex align-center"
      :color="$vuetify.theme.secondary"
      elevation="0"
      dark
    >
      <img src="../../../../assets/img/messaging.png" alt="" />
      <div>
        <p>Package: {{ packageName }}</p>
        <h1>{{ common.numberWithCommas(remaining) }} Remaining</h1>
        <p class="mb-0">
          Of {{ common.numberWithCommas(total) }} Total Package
        </p>
      </div>
    </v-card>
    <v-card
      class="card-curvey d-flex align-center"
      :color="$vuetify.theme.warning"
      elevation="0"
      dark
    >
      <img src="../../../../assets/img/campagin.png" alt="" />
      <div>
        <h1>
          {{
            overallData.campaignsDetails.total_campaigns
              ? common.numberWithCommas(
                  overallData.campaignsDetails.total_campaigns
                )
              : 0
          }}
          Campaigns
        </h1>
        <p class="mb-0">
          {{ overallData.campaignsDetails.sent_campaigns_count }} Sent
        </p>
      </div>
    </v-card>

    <v-card
      class="card-curvey d-flex align-center"
      :color="$vuetify.theme.third"
      elevation="0"
      dark
    >
      <img src="../../../../assets/img/message-campagins.png" alt="" />
      <div>
        <h1>
          {{ totalMessages }}
          Messages
        </h1>
        <p class="mb-0">Sent To User</p>
      </div>
    </v-card>

    <!-- <v-card
      class="card-curvey d-flex align-center"
      :color="$vuetify.theme.primary"
      elevation="0"
      dark
    >
      <img src="../../../../assets/img/tier-white.png" alt="" />
      <div>
        <h1>Tier</h1>
        <p class="mb-0">
          {{ common.numberWithCommas(10000) }} Business-initiated conversations
        </p>
        <small>In a rolling 24-hour period</small>
      </div>
    </v-card> -->
  </div>
</template>

<script>
import common from "../../../../utils/analytics/common";
export default {
  name: "campaignsNumbers",
  props: {
    overallData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      common,
      result: null,
      campaignPackage: "",
    };
  },
  mounted() {
    if (this.overallData.campaignsDetails.campaignPackages) {
      this.campaignPackage =
        this.overallData.campaignsDetails.campaignPackages[0];
    }
  },
  computed: {
    consumed() {
      return (
        (this.overallData.package &&
          this.overallData.package.session_consumed) ||
        0
      );
    },
    total() {
      return (
        (this.overallData.package && this.overallData.package.session_limit) ||
        0
      );
    },
    remaining() {
      return this.total - this.consumed;
    },
    totalMessages() {
      let statusToCount = this.overallData.accumulatedMsgsStatus.filter(
        (e) => e.label != "FAILED"
      );
      return this.$_.sumBy(statusToCount, (s) => s.count);
    },
    packageName() {
      return (this.overallData.package && this.overallData.package.name) || "";
    },
  },
  methods: {},
};
</script>

<style scoped>
img {
  width: 45px;
  max-width: 45px;
  margin-right: 30px;
}
@media (max-width: 1627px) {
  h1 {
    font-size: 22px;
  }
}
@media (max-width: 1440px) {
  h1 {
    font-size: 18px;
  }
}
.card-curvey {
  border: 2px solid white !important;
}
</style>
